/* -----------------Date Constants--------------- */
export const DATE_FORMAT = "MMMM dd, yyyy";
export const SHORT_DATE_FORMAT = "MM/dd/yyyy";
export const TIME_FORMAT = "HH:mm";
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
